import { Button, Input, TextField } from "@heroui/react";
import { FlagType, type FlagValue, type StoryFlagDef } from "@storyline/shared";
import SelectField, { type SelectOption } from "@/src/common/components/select-field";

type ClauseEditorProps = {
	flags: StoryFlagDef[];
	flag: string;
	operator: string;
	operatorOptions: SelectOption[];
	value: FlagValue;
	onChange: (next: { flag: string; operator: string; value: FlagValue }) => void;
	onRemove: () => void;
};

const BOOLEAN_OPTIONS: SelectOption[] = [
	{ value: "true", label: "vrai" },
	{ value: "false", label: "faux" },
];

const ClauseEditor: React.FC<ClauseEditorProps> = ({ flags, flag, operator, operatorOptions, value, onChange, onRemove }) => {
	const flagOptions: SelectOption[] = flags.map((declared) => ({ value: declared.name, label: declared.name }));
	const declared = flags.find((candidate) => candidate.name === flag);
	const isBoolean = declared?.type === FlagType.BOOLEAN;

	return (
		<div className="flex flex-wrap items-center gap-2 rounded-lg border border-border-soft bg-glass p-2">
			<SelectField options={flagOptions} value={flag} placeholder="flag" onChange={(next) => onChange({ flag: next, operator, value })} />
			<SelectField options={operatorOptions} value={operator} onChange={(next) => onChange({ flag, operator: next, value })} />
			{isBoolean ? (
				<SelectField
					options={BOOLEAN_OPTIONS}
					value={value === true ? "true" : "false"}
					onChange={(next) => onChange({ flag, operator, value: next === "true" })}
				/>
			) : (
				<TextField
					value={typeof value === "number" ? String(value) : "0"}
					onChange={(next) => onChange({ flag, operator, value: Number.parseInt(next, 10) || 0 })}
					className="w-24"
				>
					<Input type="number" />
				</TextField>
			)}
			<Button size="sm" variant="ghost" className="text-danger" onPress={onRemove}>
				×
			</Button>
		</div>
	);
};

export default ClauseEditor;
